import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { currencies } from "../../store/currencies/actions";
export var GetCurrencies = function (trigger, enable, orderBy, orderDir, page, limit) {
    var dispatch = useDispatch();
    var _a = useSelector(function (state) {
        var _a;
        return ({
            responseCurrencies: (_a = state.Currencies.responseCurrencies) === null || _a === void 0 ? void 0 : _a.data,
            errorCurrencies: state.Currencies.errorCurrencies,
            loadingCurrencies: state.Currencies.loadingCurrencies,
        });
    }), responseCurrencies = _a.responseCurrencies, errorCurrencies = _a.errorCurrencies, loadingCurrencies = _a.loadingCurrencies;
    useEffect(function () {
        if (trigger) {
            dispatch(currencies({
                enable: enable,
                orderBy: orderBy,
                orderDir: orderDir,
                page: page,
                limit: limit,
            }));
        }
    }, [trigger]);
    return {
        responseCurrencies: responseCurrencies,
        errorCurrencies: errorCurrencies,
        loadingCurrencies: loadingCurrencies,
    };
};
